module.exports = __webpack_public_path__ + "img/03n.ff7a0d30.svg";